module.exports = __webpack_public_path__ + "static/resolu-entete-offre-094bb1d379378de6eb4cae1f0afd38b6.png";